import Axios from "axios";
import * as serviceURL from "./service-url";

export const subscriptionSave = (id, request, headers, params) => {
  return Axios.post(`${serviceURL.subscriptionSave}` + id, request, {
    headers: headers,
    params: params,
  });
};

export const updateSubscription = (id, subscriptionData) => {
  return Axios.post(`${serviceURL.subscriptionSave}` + id, subscriptionData);
};

export const getuserProfileDetail = (id) => {
  return Axios.get(`${serviceURL.getuserProfileDetailById}` + id);
};
export const getblockReason = () => {
  return Axios.get(`${serviceURL.blockReason}`);
};
export const activateCard = (id) => {
  return Axios.post(`${serviceURL.activateCard}` + id);
};

export const blockUser = (id, blockReasonId) => {
  return Axios.post(
    `${serviceURL.blockUser}` + id + "?blockReasonId=" + blockReasonId
  );
};
export const unblockUser = (id) => {
  return Axios.post(`${serviceURL.unblockUser}` + id, {});
};

export const removeUserAccount = (id) => {
  return Axios.post(`${serviceURL.removeUserAccount}` + id);
};

export const sendPassword = (id) => {
  return Axios.post(`${serviceURL.sendPassword}` + id, {});
};

export const updateEidNumberService = (req) => {
  return Axios.post(`${serviceURL.updateEIDNumber}`, req);
};

export const viewKyc = (id) => {
  return Axios.get(`${serviceURL.viewKyc}` + id);
};

export const enableSelfieBypass = (userId, reason) => {
  return Axios.post(serviceURL.enableSelfieBypass, {
    userId: userId,
    reason: reason
  });
};

export const disableSelfieBypass = (userId) => {
  return Axios.post(serviceURL.disableSelfieBypass, {
    userId: userId
  });
};
